module.exports = __webpack_public_path__ + "static/media/chanel_rsvp_banner_desktop.14cebcf2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/chanel_rsvp_banner_desktop.jpg
// module id = 369
// module chunks = 0